// export const ADMIN_ACTIONS    = ['manage_users', "manage_companies", "manage_own_users"]

export const MANAGE_USERS     = ['manage_users', 'manage_own_users']
export const MANAGE_COMPANIES = ['manage_companies']
export const ADMIN_ACTIONS    = [...MANAGE_COMPANIES, ...MANAGE_USERS]

export const GRID_PAGE_SIZE_OPTIONS = ['10', '15', '25', '50', '100'];
